import { useCallback, useState } from 'react'

import { useDecision } from '@optimizely/react-sdk'
import useSWR from 'swr'

import { fetchLandingExperience } from '@library/api-customer-engagement-experience'
import type { LandingExperienceData } from '@library/api-customer-engagement-experience'

type UseGoustoAnytimeExperimentResult = {
  showModal: boolean
  data: LandingExperienceData | null
  dismiss: () => void
}

export function useGoustoAnytimeExperiment(): UseGoustoAnytimeExperimentResult {
  const [dismissed, setDismissed] = useState(false)
  const [decision] = useDecision('tomatoes_ofx_webclient_gousto_anytime')

  const { data: response } = useSWR(
    decision.enabled ? 'gousto-anytime' : null,
    fetchLandingExperience,
  )

  const dismiss = useCallback(() => setDismissed(true), [])

  const modalData = response?.status === 200 ? response.data : null
  const showModal = !dismissed && modalData !== null

  return {
    showModal,
    data: modalData,
    dismiss,
  }
}
